import { createStore } from 'vuex'
import common from './common/index.js'
import search from './search/index.js'
import h5Module from './modules/H5/index.js'
import { productInitList } from '../common/productInitData'
import { fetchData } from '../utils/fetch.js'

const store = createStore({
  modules: {
    common,
    search,
    h5Module
  },
  state () {
    return {
      productList: [],
      productListCopy: productInitList, // 首页推荐商品列表兜底数据，防止接口异常
      supplierFee: {
        suppliersUrl: '',
        suppliersName: '',
        supplierFee: 0
      },
      searchInfo: {
        pageNow: 1,
        pageSize: 20,
        keyword: '',
        imageId: 0,
        region: ''
      },
      loading: false,
      mergedArray: [],
      currentCountry: {},
      emptyObj: {},
      initSkeleton: undefined,
      loadMoreSleleton: false,
      passiveLogin: 0,
      isMobile: /iphone|ipod|ipad|android|blackberry|windows phone/i.test(navigator.userAgent.toLowerCase()) ? 'MOBILE' : 'PC'
    }
  },
  mutations: {
    setProductList (state, payload) {
      state.productList = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setSearchInfo (state, payload) {
      state.searchInfo = payload
    },
    setMergedArray (state, payload) {
      state.mergedArray = payload
    },
    setEmptyObj (state, payload) {
      state.emptyObj = payload
    },
    setInitSkeleton (state, payload) {
      state.initSkeleton = payload
    },
    setLoadMoreSleleton (state, payload) {
      state.loadMoreSleleton = payload
    },
    setPassiveLogin (state, payload) {
      state.passiveLogin = payload
    },
    setProductListCopy (state, payload) {
      state.productListCopy = payload
    }
  },
  actions: {
    setProduct (ctx, payload) {
      const { state, commit } = ctx
      const list = state.productList.map((v) => {
        return {
          ...v,
          priceInfo: { price: v.priceInfo.price, ...payload }
        }
      })
      commit('setProductList', list)
    },
    async initHomeData (ctx, payload) {
      const { state, commit } = ctx
      commit('setLoadMoreSleleton', true)
      const { adsWord } = payload
      const queryData = adsWord ? `/appb/b2b/product/recommend/productListV2?itemNumber=60&adsWord=${encodeURIComponent(adsWord).replace(/%20/g, '+')}` : '/appb/b2b/product/recommend/productListV2?itemNumber=20'
      const { data, code } = await fetchData(queryData)
      if (code === 200 && data && data.length) {
        commit('setProductList', data)
        commit('setProductListCopy', data) // 备份
      } else {
        const currencyData = JSON.parse(localStorage.getItem('currencyData')) || {}
        const list = state.productListCopy.map(v => {
          return {
            ...v,
            priceInfo: { price: v.priceInfo.price, ...currencyData }
          }
        })
        commit('setProductList', list)
      }
      commit('setLoadMoreSleleton', false)
    },
    async loadMoreHomeData (ctx, payload) {
      const { state, commit } = ctx
      commit('setLoadMoreSleleton', true)
      const { data, code } = await fetchData('/appb/b2b/product/recommend/productListV2?itemNumber=20')
      if (code === 200 && data && data.length) {
        commit('setProductList', [...state.productList, ...data])
        commit('setProductListCopy', [...state.productList, ...data]) // 备份
      } else {
        const currencyData = JSON.parse(localStorage.getItem('currencyData')) || {}
        const list = state.productListCopy.map(v => {
          return {
            ...v,
            priceInfo: { price: v.priceInfo.price, ...currencyData }
          }
        })
        commit('setProductList', list)
      }
      commit('setLoadMoreSleleton', false)
      commit('search/SET_PRE_SEARCH', false)
    }
  }
})

export default store
